export default "__VITE_ASSET__CWEnuUUz__"